export default __webpack_public_path__ + "static/media/Diamond-etched Girdle.ce37a916.jpg";